export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_02-end.10f684fd.jpg";